import { LinkedinCards } from "domain/entities/linkedincards";
import { ILinkedinCardsRepository } from "domain/contracts/linkedincards.contract";
import { httpClient } from "infra/axios/axios-api";
import { LinkedinCardsInputFilters } from "domain/models/linkedincards-input-filters";
import { Message } from "domain/entities/message";

class LinkedinCardsRepository implements ILinkedinCardsRepository {
   
    async getAll(filter: LinkedinCardsInputFilters): Promise<Message<LinkedinCards[]>> {
      const response = await httpClient.get(`/openPositions`, {
      params: filter,
      });
      return response.data;
    }
    async getById(id: string): Promise<Message<LinkedinCards>> {
      const response = await httpClient.get(`/openPositions/${id}`);
      return response.data;
    }
    async create(input: LinkedinCards): Promise<Message<LinkedinCards>> {
      const response = await httpClient.post(`/openPositions`, input);
      return response.data;
    }
    async delete(id: string): Promise<Message<boolean>> {
      const response = await httpClient.delete(`/openPositions/${id}`);
      return response.data;
    }
    async getRanking(groupBy: string, page: number, limit: number, filters?: any): Promise<Message<any[]>> {
      const response = await httpClient.get(`/openPositions/ranking`, {
        params: { groupBy, page, limit, ...filters },
      });
      return response.data;
    }
    async getDashboardStats(filters?: any): Promise<Message<any>> {
      const response = await httpClient.get(`/openPositions/dashboard-stats`, {
        params: filters,
      });
      return response.data;
    }
    async getFilterOptions(): Promise<Message<{ companies: string[]; positions: string[]; titles: string[]; countries: string[]; cities: string[] }>> {
      const response = await httpClient.get(`/openPositions/filter-options`);
      return response.data;
    }
}

export default new LinkedinCardsRepository();
